// extracted by mini-css-extract-plugin
module.exports = {"o1niwk7v":"o1niwk7v","c1419mng":"c1419mng","w1hs08j5":"w1hs08j5","sx8x7yz":"sx8x7yz","s1ahchi3":"s1ahchi3"};